// extracted by mini-css-extract-plugin
export default {"wp_exchange_box":"WpExchange_wp_exchange_box__BYSua"};